/* ============================================================
   ZENITH APPAREL — Wishlist (localStorage, no account needed)
   ============================================================ */
(function() {
  var KEY = 'zenith_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateCounts(list);
  }
  function has(list, handle) {
    return list.some(function(i) { return i.handle === handle; });
  }
  function updateCounts(list) {
    list = list || read();
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = '(' + list.length + ')';
      el.hidden = list.length === 0;
    });
  }

  /* ---- Product page heart ---- */
  var btn = document.querySelector('.product__wishlist-btn');
  if (btn && btn.dataset.handle) {
    var sync = function() {
      var saved = has(read(), btn.dataset.handle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    };
    btn.addEventListener('click', function() {
      var list = read();
      if (has(list, btn.dataset.handle)) {
        list = list.filter(function(i) { return i.handle !== btn.dataset.handle; });
      } else {
        list.push({
          handle: btn.dataset.handle,
          title: btn.dataset.title,
          price: btn.dataset.price,
          image: btn.dataset.image,
          url: btn.dataset.url
        });
      }
      write(list);
      sync();
    });
    sync();
  }

  /* ---- Wishlist page grid ---- */
  var grid = document.getElementById('WishlistGrid');
  if (grid) {
    var esc = function(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };
    var render = function() {
      var list = read();
      var empty = document.getElementById('WishlistEmpty');
      if (empty) empty.hidden = list.length > 0;
      grid.innerHTML = list.map(function(i) {
        return '<div class="wishlist-card">' +
          '<a href="' + esc(i.url) + '" class="wishlist-card__media">' +
            (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="wishlist-card__info">' +
            '<a href="' + esc(i.url) + '" class="wishlist-card__title">' + esc(i.title) + '</a>' +
            '<span class="wishlist-card__price">' + esc(i.price) + '</span>' +
            '<button type="button" class="wishlist-card__remove btn-reset" data-handle="' + esc(i.handle) + '">Remove</button>' +
          '</div>' +
        '</div>';
      }).join('');
      grid.querySelectorAll('.wishlist-card__remove').forEach(function(b) {
        b.addEventListener('click', function() {
          write(read().filter(function(i) { return i.handle !== b.dataset.handle; }));
          render();
        });
      });
    };
    render();
  }

  updateCounts();
})();
